<template>
  <div class="flex flex-col divide-y divide-neutral-200 dark:divide-neutral-950">
    <slot />
  </div>
</template>